import http from '@/utils/network/http/axios'

const { MANAGE } = process.env

/**
 * 上传头像（同步到腾讯云）
 * @param {*} params: {keyword, keyword, pageSize}
 */
 export function userfaceadd(params) {
  return http.post(`/user/userfaceadd`, params)
}

/**
 * 修改密码
 * @param {*} params: {keyword, keyword, pageSize}
 */
 export function updatePwd(params) {
  return http.post(`/user/updatePwd`, params)
}

/**
 * 获取登录用户信息
 * @param {*} params: {keyword, keyword, pageSize}
 */
 export function getUserInfo(params) {
  return http.post(`/user/getUserInfo`, params)
}

/**
 * 角色模块-获取列表
 * @param {*} params: {keyword, keyword, pageSize}
 */
export function getRoleList(params) {
  return []
  // return http.post(`${MANAGE}/admin/getRoleList`, params)
}
/**
 * 角色模块-删除角色
 * @param {*} params: {roleId}
 */
export function deleteRole(params) {
  return http.post(`${MANAGE}/admin/deleteRole`, params)
}
/**
 * 角色模块-添加角色
 * @param {*} params: {roleName, rightList}
 */
export function addRole(params) {
  return http.post(`${MANAGE}/admin/addRole`, params)
}
/**
 * 角色模块-修改角色
 * @param {*}
 */
export function updateRole(params) {
  return http.post(`${MANAGE}/admin/updateRole`, params)
}
/**
 * 角色模块-获取权限列表
 * @param {*}
 */
export function getRightList() {
  return http.post(`${MANAGE}/admin/getRightList`)
}
/**
 * 用户模块-获取管理员列表
 * @param {*} params: {keyword, keyword, pageSize}
 */
export function getAdminList(params) {
  return http.post(`${MANAGE}/admin/getAdminList`, params)
}
/**
 * 用户模块-添加管理员
 * @param {*} params: {userName, userAccount, phone, roleList, password}
 */
export function addAdmin(params) {
  return http.post(`${MANAGE}/admin/addAdmin`, params)
}
/**
 * 用户模块-修改管理员
 * @param {*} params: {userId, userName, userAccount, phone, roleList, password}
 */
export function updateAdmin(params) {
  return http.post(`${MANAGE}/admin/updateAdmin`, params)
}
/**
 * 用户模块-修改密码，无需原密码
 * @param {*} params: {userId, userName, userAccount, phone, roleList, password}
 */
export function resetMyPwd(params) {
  return http.post(`${MANAGE}/admin/resetMyPwd`, params)
}
/**
 * 用户模块-删除管理员
 * @param {*} params: {userId}
 */
export function deleteAdmin(params) {
  return http.post(`${MANAGE}/admin/deleteAdmin`, params)
}
/**
 * 用户模块-重置管理员密码
 * @param {*} params: {userId, password}
 */
export function resetPwd(params) {
  return http.post(`${MANAGE}/admin/resetPwd`, params)
}

/**
 * 添加机构二维码
 * @param {*} 
 */
 export function organEwmAdd(params) {
  return http.post(`/user/organEwmAdd`, params)
}

/**
 * 获取机构二维码
 * @param {*} 
 */
 export function organEwmDetail(params) {
  return http.post(`/user/organEwmDetail`, params)
}

/**
 * 删除机构二维码
 * @param {*} 
 */
 export function organEwmDel(params) {
  return http.post(`/user/organEwmDel`, params)
}

/**
 * 获取所有注册用户
 * @param {*} 
 */
export function getUserList(params) {
  return http.post(`/user/getUserList`, params)
}

